'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Artists = {

    async getAll() {
		try {
            let response = await axios.get(API_URL + '/artists', await getHeader());
			
			return response.data;

		} catch(error) {
            return false;
		}
	},

	async createNew(name, birthDate = null, deathDate = null, circa = null, BC = null) {
		try {
			if (!name) {
				return { error: "The artist name is mandatory" };
			}

			const header = await getHeader();

			let response = await axios.post(API_URL + '/artist', {
				"name": name,
				"dateOfBirth": !birthDate ? null : birthDate,
				"dateOfDeath": !deathDate ? null : deathDate,
				"circa": circa,
				"bc": BC
			}, header);

			return !response.data.id ? false : response.data;

		} catch(error) {
			return false;
		}
	},

	async approve(artistID) {
		try {
			if (!artistID) {
				return { error: "The artist ID is mandatory" };
			}

			const header = await getHeader();

			let response = await axios.post(API_URL + '/artist/approve/' + artistID, {
				"approved": true
			}, header);

			return !response.data.id ? false : response.data;

		} catch(error) {
			return false;
		}
	},

	async update(artistID, name, birthDate = null, deathDate = null, circa = null, BC = null) {
		try {
			if (!artistID || !name) {
				return { error: "The artist name is mandatory" };
			}

			const header = await getHeader();

			let response = await axios.patch(API_URL + '/artist/' + artistID, {
				"name": name,
				"dateOfBirth": birthDate,
				"dateOfDeath": deathDate,
				"circa": circa,
				"bc": BC
			}, header);

			if (response.data.id) {
				return response.data;
			} else {
				return false;
			}

		} catch(error) {
			return false;
		}
	},

	async uploadImage(artistID, filename, content) {
		try {
			if (!artistID || !filename || !content) {
				return { error: 'A mandatory field is missing' };
			}

			let header = await getHeader();
			let response = await axios.post(API_URL + '/artist/upload/' + artistID, {
				"fileName": filename,
				"content": content
			}, header);

			return !response.data.image ? false : response.data;
		
		} catch(error) {
            return false;
		}

	},

	async delete(artistID) {
		try {
			if (!artistID) {
				return { error: 'The artist ID is missing.' };
			}

			const header = await getHeader();

			let response = await axios.delete(API_URL + '/artist/' + artistID, header);

			if (response.data.message.includes('Successfully deleted the artist')) {
                return true;
			}
			
			return false;
		
		} catch(error) {
			return false;
		}
	}
    
}

export default Artists;
